module.exports = __webpack_public_path__ + "img/menu-03.ecc2c66c.svg";